import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';

import { CouncilService } from './shared/council.service';

import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule, AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestoreModule, SETTINGS } from '@angular/fire/compat/firestore';

import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import { ProgramGroupService } from './shared/program-group.service';
import { ActivityListComponent } from './activity-list/activity-list.component';
import { EnterActivityComponent } from './enter-activity/enter-activity.component';
import { SubmissionsClosedComponent } from './submissions-closed/submissions-closed.component';
import { ProgramGroupFilterPipe } from './shared/program-group-filter.pipe';
import { GradeActivityComponent } from './grade-activity/grade-activity.component';
import { CouncilSummaryComponent } from './council-summary/council-summary.component';
import { ApprovedActivityFilterPipe } from './shared/approved-activity-filter.pipe';

import { CovalentLayoutModule } from '@covalent/core/layout';
import { GoogleChartsModule } from 'angular-google-charts';

import { FirebaseUIModule, firebase } from 'firebaseui-angular';
import { LoginComponent } from './login/login.component';

import { redirectUnauthorizedTo, redirectLoggedInTo, canActivate, AngularFireAuthGuard } from '@angular/fire/compat/auth-guard';
import { HeaderLogoComponent } from './header-logo/header-logo.component';
import { StateSummaryComponent } from './state-summary/state-summary.component';
import { HttpClientModule } from '@angular/common/http';
import { GenerateReportsComponent } from './generate-reports/generate-reports.component';
import { GoogleAnalyticsService } from './shared/google-analytics.service';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToActivities = () => redirectLoggedInTo(['activities']);

const appRoutes: Routes = [
  { 
    path: '', 
    component: CouncilSummaryComponent, 
    /*canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },*/
    pathMatch: 'full'
  },
  { 
    path: 'council-summary', 
    component: CouncilSummaryComponent,
    /*canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }*/
  },
  { 
    path: 'council-summary/:id', 
    component: CouncilSummaryComponent,
    /*canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }*/
  },
  //{ path: '', component: EnterActivityComponent, pathMatch: 'full' },
  //{ path: '', component: SubmissionsClosedComponent, pathMatch: 'full' },
  {
    path: 'activities',
    component: ActivityListComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'grade-activity/:id',
    component: GradeActivityComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'state-summary',
    component: StateSummaryComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'generate-reports',
    component: GenerateReportsComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToActivities }
  },
  { path: '**', redirectTo: '' },
];

const firebaseUiAuthConfig = {
  signInFlow: 'popup',
  signInOptions: [
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID
  ]
};

@NgModule({
  declarations: [
    AppComponent,
    ActivityListComponent,
    EnterActivityComponent,
    SubmissionsClosedComponent,
    ProgramGroupFilterPipe,
    ApprovedActivityFilterPipe,
    GradeActivityComponent,
    CouncilSummaryComponent,
    LoginComponent,
    HeaderLogoComponent,
    StateSummaryComponent,
    GenerateReportsComponent
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    FirebaseUIModule.forRoot(firebaseUiAuthConfig),
    ReactiveFormsModule,
    GoogleChartsModule,
    CovalentLayoutModule,
    HttpClientModule
  ],
  providers: [
    CouncilService,
    ProgramGroupService,
    GoogleAnalyticsService,
    AngularFireAuthGuard,
    { provide: SETTINGS, useValue: {} }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
